import angular from 'angular';
import angularRedux from '@buildium/angular-redux';
import 'oclazyload';
import { LocalizationModule } from '@buildium/angularjs-core/dist/localization';
import { AccessConstantsModule } from '@buildium/angularjs-core/dist/constants/access';
import { AccountConstantsModule } from '@buildium/angularjs-core/dist/constants/account';
import { ManagerApiModule } from '../api/manager-api.module';
import { FeatureFlagsService} from './feature-flags';
import { PasswordStrengthIndicatorModule} from '../components/password/password-strength-indicator/password-strength-indicator.module';
import { ResetPasswordModalComponent } from './components/reset-password-modal/reset-password-modal';
import {SettingsSaveBarComponent} from './components/settings-save-bar/settings-save-bar';
import {FormSaveBarComponent} from './components/form-save-bar/form-save-bar';
import { SettingsService } from './settings';
import {TwoFactorVerificationSimpleCodeInputModule} from '../components/two-factor-verification-simple-code-input/two-factor-verification-simple-code-input.module';
import { RENT_INCREASE_TYPES, ROUND_RULES } from './constants/default-offers';
import { SessionStorageCacheService } from './session-storage-cache';
import { ManagerLocalizationModule } from '../localization/localization.module';
import {ADD_ON_SERVICE_STATUS, ADD_ON_SERVICE_TYPE} from './constants';
import { FREE_EPAY_SETUP_CREDITS_ENUM } from '../../manager-base/billing/Constants/free-epay-setup-credits.enum';
import {SettingsState} from './state/settings-state.module';
import {ReduxFeatureFlagsActions} from './redux-feature-flags';
import {MobileBannerModule} from '../mobile-banner/mobile-banner.module.ts';
import {GlobalizeLoaderModule} from '../globalize-loader/globalize-loader.module.ts';
import { SetupApplicationFeesBankAccountModalComponent } from './components/setup-application-fees-bank-account-modal/setup-application-fees-bank-account-modal';
import {LOCAL_STORAGE_KEYS} from './constants/local-storage-keys';
import { RETURNED_PAYMENT_SETTING_TYPE } from './constants/returned-payment-setting-type.enum';

export const SettingsServiceModule = angular.module('buildium.settings.service', [
    ManagerApiModule.name,
    LocalizationModule.name,
    AccessConstantsModule.name,
    AccountConstantsModule.name,
    MobileBannerModule.name,
    GlobalizeLoaderModule.name
])
    .service('Settings', SettingsService);

export const ManagerSettingsModule = angularRedux.createModule('buildium.manager.settings', [
    ManagerLocalizationModule.name,
    ManagerApiModule.name,
    PasswordStrengthIndicatorModule.name,
    TwoFactorVerificationSimpleCodeInputModule.name,
    SettingsServiceModule.name,
    'oc.lazyLoad'
], SettingsState)
    // constants
    .constant('RENT_INCREASE_TYPES', RENT_INCREASE_TYPES)
    .constant('ROUND_RULES', ROUND_RULES)
    .constant('ADD_ON_SERVICE_STATUS', ADD_ON_SERVICE_STATUS)
    .constant('ADD_ON_SERVICE_TYPE', ADD_ON_SERVICE_TYPE)
    .constant('LOCAL_STORAGE_KEYS', LOCAL_STORAGE_KEYS)
    .constant('FREE_EPAY_SETUP_CREDITS_ENUM', FREE_EPAY_SETUP_CREDITS_ENUM)
    .constant('RETURNED_PAYMENT_SETTING_TYPE', RETURNED_PAYMENT_SETTING_TYPE)

    // services
    .service('FeatureFlags', FeatureFlagsService)
    .service('ReduxFeatureFlags', ReduxFeatureFlagsActions)
    .service('SessionStorageCacheService', SessionStorageCacheService)

    // components
    .component('bdResetPasswordModal', ResetPasswordModalComponent)
    .component('bdSettingsSaveBar', SettingsSaveBarComponent)
    .component('bdFormSaveBar', FormSaveBarComponent)
    .component('bdSetupApplicationFeesBankAccountModal', SetupApplicationFeesBankAccountModalComponent);
